module.exports = __webpack_public_path__ + "img/reset-password.f250fc7b.png";